import {
  MDBBtn,
  MDBCheckbox,
  MDBChip,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBPopconfirm,
  MDBPopconfirmMessage,
  MDBSpinner
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getGlobalLocationList, getugroups, setGlobalLocationFilter } from "../../apiclients/streamsapi_bridge";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import DeleteGroupsFilter from "../../views/popups/users/DeleteGroupsFilter";
import { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";
import { isFiveNineAccount } from "../../views/Login";
import CommonMoreOptions from "../../apiclients/CommonMoreOptions";
import ImportProgressWarning from "../../apiclients/ImportProgressWarning";
import ImpExpRedirectPopup from "../../apiclients/ImpExpRedirectPopup";
import ImportUser from "../editviews/user/ImportUser";

export default function UGroups(props) {
  /************************************************************************/
  const [groups, setGroups] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isloading, setIsloading] = useState(true);
  const deleteLocRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [proccessdRows, setProccessdRows] = useState([]); 
  const [searchValue, setsearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null); 
  const [allChecked, setallChecked] = useState(false);
  const [disableMulti, setdisableMulti] = useState(true);
  const [groupList, setgroupList] = useState([]);
  const [groupNames, setgroupNames] = useState([]);
  const isFiveNineAccounts = isFiveNineAccount();
  const [DropDownitem, setDropDownitem] = useState([
    {
      label: "Caller-ID",
      key: "caller-id",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Location",
      key: "location",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Billing Group",
      key: "billing-group",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Seat Plan",
      key: "seat-plan",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Permission Role",
      key: "permission-role",
      show: !isFiveNineAccounts,
    },
    {
      label: "Add to a Group",
      key: "add-group",
      show: !isFiveNineAccounts,
    },
    {
      label: "Resend Welcome Email",
      key: "resend-email",
    },
  ]);



  /*************************************************************************/
  function showThisInf(tdata) {
    navigate("/usersgroups", {
      state: tdata.groupInfo,
    });
  }

  function handleClick() {
    deleteLocRef.current.click();
  }
useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)

 const handleAllChecked = (isChecked) => {
  const typeMap = {
    "User Group": 5,
    "Hunt Group": 0,
    "Acd Queue": 3,
  };

  if (isChecked) {
    setallChecked(true);

    const grpObjs = [];
    const grpNames = [];

    filteredRows.forEach(({ groupInfo }) => {
      grpObjs.push({
        id: groupInfo.entity_id + "",
        type: typeMap[groupInfo.group_type] ?? null
      });
      grpNames.push(groupInfo.title); // or groupInfo.name if API gives name
    });

    setgroupList(grpObjs);
    setgroupNames(grpNames);
    setdisableMulti(false);

  } else {
    setallChecked(false);
    setgroupList([]);
    setgroupNames([]);
    setdisableMulti(true);
  }
};

  function handleCheckedRow(e, selectrow) {
    const typeMap = {
      "User Group": 5,
      "Hunt Group": 0,
      "Acd Queue": 3,
    };

    const groupObj = {
      id: selectrow.entity_id + "",
      type: typeMap[selectrow.group_type] ?? null
    };

    let updatedGroups = [];
    let updatedGroupNames = [];

    if (e.target.checked) {
      // Add
      updatedGroups = [...groupList, groupObj];
      updatedGroupNames = [...groupNames, selectrow.name];
    } else {
      // Remove
      updatedGroups = groupList.filter(
        (item) => !(item.id + "" === groupObj.id + "" && item.type === groupObj.type)
      );
      updatedGroupNames = groupNames.filter(
        (name) => name !== selectrow.name
      );
    }

    // Check All Selected
    const allSelected = filteredRows.length > 0
      ? filteredRows.every(row =>
        updatedGroups.some(g => g.id + "" === row.entity_id + "" && g.type === typeMap[row.group_type])
      )
      : false;

    setallChecked(allSelected);

    // Disable multi if no selection
    setdisableMulti(updatedGroups.length === 0);

    // Update states
    setgroupList(updatedGroups);
    setgroupNames(updatedGroupNames);
  }


  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getugroups(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const rawData = await response.json();
    if (!rawData) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("groups having users response  :::: " + JSON.stringify(rawData));
    setGroups(rawData?.groups ?? []);
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
  }
  useEffect(() => {

  let proccessdRows = [];
  groups.map((group) => {
    proccessdRows.push({
      groupInfo: group,
      checkBoxValue: (
        <MDBCheckbox
          checked={groupList.some((g) => g.id + "" === group.entity_id + "")}
          onClick={(e) => handleCheckedRow(e, group)}
        />
      ),
      name: group.title,
      type: group.group_type,
      usercount: group.users_count,

    })
  }
)
setProccessdRows(proccessdRows);
setFilteredRows(proccessdRows);
setDataLoaded(true)
}, [groups,props.isActive]);

  useEffect(() => {
  setFilteredRows(filteredRows.map((group) => ({
    ...group,
    checkBoxValue: (
      <MDBCheckbox
        checked={groupList.some((g) => g.id + "" === group.groupInfo.entity_id + "")}
        onClick={(e) => handleCheckedRow(e, group.groupInfo)}
      />
    )
  })));
}, [groupList]);


  const basicData = {
    columns: [
      {
        label: (<>
          <MDBCheckbox checked={allChecked} onChange={(e) => handleAllChecked(e.target.checked)} />
        </>), field: "checkBoxValue", sort: false
      },
      { label: 'Name', field: 'name' },
      { label: 'Type', field: 'type' },
      { label: 'Users', field: 'usercount' },
    ],
    rows: filteredRows,
  };
  /********************************Fetching Display Data Starts Here!************************************************* */
  useEffect(() => {
    fetchData();
  }, []);

  /********************************************************************************* */




  const [addFilter, setAddFilter] = useState(false);
  const [showHuntGroup, setShowHuntGroup] = useState(false);
  const [showACQQueue, setShowACQQueue] = useState(false);
  const [userGroups, setUserGroups] = useState(false);

  const [hgSelected, setHGSelected] = useState("");
  const [ugSelected, setUGSelected] = useState("");
  const [hgSelectedIds, setHGSelectedIds] = useState([]);
  const [ugSelectedIds, setUGSelectedIds] = useState([]);
  const [newHGroupSelectedIds, setNewHGroupSelectedIds] = useState([]);
  const [newUGroupSelectedIds, setNewUGroupSelectedIds] = useState([]);
  const [existHGSelectIds, setexistHGSelectIds] = useState([]);
  const [existUGSelectIds, setexistUGSelectIds] = useState([]);
  const [existNewHGSelectIds, setexistNewHGSelectIds] = useState([]);
  const [existNewUGSelectIds, setexistNewUGSelectIds] = useState([]);
  const [filterHuntGList, setfilterHuntGList] = useState([]);
  const [filterUserGList, setfilterUserGList] = useState([]);
  const [displayHGFilter, setdisplayHGFilter] = useState([]);
  const [displayUGFilter, setdisplayUGFilter] = useState([]);
  const [displayNewHGFilter, setdisplayNewHGFilter] = useState([]);
  const [displayNewUGFilter, setdisplayNewUGFilter] = useState([]);
  const [reRender, setreRender] = useState(true);
  const [searchHGValue, setsearchHGValue] = useState("");
  const [searchUGValue, setsearchUGValue] = useState("");
  const [searchNewHGValue, setsearchNewHGValue] = useState("");
  const [searchNewUGValue, setsearchNewUGValue] = useState("");
  const [deleteFilter, setdeleteFilter] = useState(false);
  const deleteFilterToggle = () => setdeleteFilter(!deleteFilter);
  const [filterKey, setfilterKey] = useState(0);
  const [allHGroup, setallHGroup] = useState(false);
  const [allNewHGroup, setallNewHGroup] = useState(false);
  const [allUGroup, setallUGroup] = useState(false);
  const [allNewUGroup, setallNewUGroup] = useState(false);

  const toggleFilter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAddFilter(!addFilter);
    setShowACQQueue(false);
    setShowHuntGroup(false);
    setUserGroups(false)
  };

  const toggleHuntGroup = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowHuntGroup(!showHuntGroup);
    setShowACQQueue(false); // Ensure other div is hidden
    setUserGroups(false);
  };

  const toggleACQQueue = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowACQQueue(!showACQQueue);
    setShowHuntGroup(false); // Ensure other div is hidden
    setUserGroups(false);
  };

  const toggleUserGroup = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setUserGroups(!userGroups);
    setShowHuntGroup(false); // Ensure other div is hidden
    setShowACQQueue(false);
  };

  const toggleBackClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowACQQueue(false); // Ensure other div is hidden
    setShowHuntGroup(false); // Ensure other div is hidden
    setUserGroups(false);
  };


  useEffect(() => {
    if (reRender) {
      // const huntGFilter = sessionStorage.getItem("huntGroupFilter") ?
      //   JSON.parse(sessionStorage.getItem("huntGroupFilter")) :
      //   [];
      // const userGFilter = sessionStorage.getItem("uGroupFilter") ?
      //   JSON.parse(sessionStorage.getItem("uGroupFilter")) :
      //   [];
      // const ugroupupdated = sessionStorage.getItem("ugroup_updated");
      // const hgroupupdated = sessionStorage.getItem("hgroup_updated");
      // if (huntGFilter && huntGFilter.length > 0 && userGFilter && userGFilter.length > 0 && !ugroupupdated && !hgroupupdated) {
      //   setTheStateValues(huntGFilter, userGFilter);

      // } else {

      //   sessionStorage.removeItem('hgroup_updated');
      //   sessionStorage.removeItem('ugroup_updated');
      getGroupsFilter();

      // }
      setreRender(false);
    }
  }, [reRender]);


  async function getGroupsFilter() {
    try {
      const adminSession = sessionStorage.getItem("admin_session");
      const siteid = JSON.parse(adminSession).siteid;
      let response;
      const extracondition = `?module_type=4`;
      response = await getGlobalLocationList(siteid, extracondition);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      // debugger;
      let rawData = await response.json();
      console.log("Group filter list ::::::::: : " + JSON.stringify(rawData));
      if (!rawData) {
        window.alert(`info with id  not found`);
        // navigate("/");
      }
      const huntgFilter = rawData?.result?.hunt_group ?? [];
      const usergFilter = rawData?.result?.user_group ?? [];
      setTheStateValues(huntgFilter, usergFilter);
      // sessionStorage.setItem("huntGroupFilter", JSON.stringify(huntgFilter));
      // sessionStorage.setItem("uGroupFilter", JSON.stringify(usergFilter));

    } catch (error) {

    }

  }

  function setTheStateValues(huntgFilter, usergFilter) {
    let huntgSelected = huntgFilter.filter(group => group.selected).map(group => group.entity_name).join(', ');
    const huntGSelectedids = huntgFilter.some(group => group.entity_id === -1 && group.selected)
      ? huntgFilter.map(group => group.entity_id)
      : huntgFilter.filter(group => group.selected).map(group => group.entity_id);
    const hindex = huntGSelectedids.findIndex(id => id === -1);
    if (hindex !== -1) {
      huntGSelectedids.splice(hindex, 1);
      huntgSelected = "";
      setNewHGroupSelectedIds(huntGSelectedids);
      setexistNewHGSelectIds(huntGSelectedids);
      setallNewHGroup(true);
    }
    const newHGFilters = huntgFilter.filter(group => parseInt(group.entity_id) != -1)


    let usergSelected = usergFilter.filter(group => group.selected).map(group => group.entity_name).join(', ');
    const userGSelectedids = usergFilter.some(group => group.entity_id === -1 && group.selected)
      ? usergFilter.map(group => group.entity_id)
      : usergFilter.filter(group => group.selected).map(group => group.entity_id);

    const uindex = userGSelectedids.findIndex(id => id === -1);
    if (uindex !== -1) {
      userGSelectedids.splice(uindex, 1);
      usergSelected = "";
      setNewUGroupSelectedIds(userGSelectedids);
      setexistNewUGSelectIds(userGSelectedids);
      setallNewUGroup(true);
    }
    const newUGFilters = usergFilter.filter(group => parseInt(group.entity_id) != -1)


    setfilterHuntGList(newHGFilters);
    setfilterUserGList(newUGFilters);
    setdisplayHGFilter(newHGFilters);
    setdisplayNewHGFilter(newHGFilters);
    setdisplayUGFilter(newUGFilters);
    setdisplayNewUGFilter(newUGFilters);
    if (huntgSelected && huntgSelected !== "") {
      setHGSelected(`${t("huntgroup")} : ${huntgSelected}`);
      setHGSelectedIds(huntGSelectedids);
      setexistHGSelectIds(huntGSelectedids);
    }
    if (usergSelected && usergSelected !== "") {
      setUGSelected(`${t("usergroups")} : ${usergSelected}`);
      setUGSelectedIds(userGSelectedids);
      setexistUGSelectIds(userGSelectedids);
    }

  }

  function cancelfilterChanges(flag) {
    if (flag === 1) {
      setHGSelectedIds(existHGSelectIds);
      if (existHGSelectIds.length === filterHuntGList.length || existHGSelectIds.length === displayHGFilter.length) {
        setallHGroup(true);
      } else {
        setallHGroup(false);
      }
    } else if (flag === 2) {
      setUGSelectedIds(existUGSelectIds);
      if (existUGSelectIds.length === filterUserGList.length || existUGSelectIds.length === displayUGFilter.length) {
        setallUGroup(true);
      } else {
        setallUGroup(false);
      }
    } else if (flag === 3) {
      setNewHGroupSelectedIds(existNewHGSelectIds);
      if (existNewHGSelectIds.length === filterHuntGList.length || existNewHGSelectIds.length === displayHGFilter.length) {
        setallNewHGroup(true);
      } else {
        setallNewHGroup(false);
      }
      setShowHuntGroup(false);
      setUserGroups(false);
    } else {
      setNewUGroupSelectedIds(existNewUGSelectIds);
      if (existNewUGSelectIds.length === filterUserGList.length || existNewUGSelectIds.length === displayUGFilter.length) {
        setallNewUGroup(true);
      } else {
        setallNewUGroup(false);
      }
      setShowHuntGroup(false);
      setUserGroups(false);

    }
  }

  const handleHGCheckboxChange = (value) => {
    const updatedValues = [...hgSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayHGFilter.length) {
      setallHGroup(false);

    } else {
      const tempArray = displayHGFilter.map(hg => hg.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallHGroup(false);
          break;
        }
      }
      setallHGroup(true);
    }
    setHGSelectedIds(updatedValues);
  };
  const handleUGCheckboxChange = (value) => {
    const updatedValues = [...ugSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayUGFilter.length) {
      setallUGroup(false);

    } else {
      const tempArray = displayUGFilter.map(hg => hg.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallUGroup(false);
          break;
        }
      }
      setallUGroup(true);
    }
    setUGSelectedIds(updatedValues);
  };

  const handleNewHFilterCheckboxChange = (value) => {
    const updatedValues = [...newHGroupSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayNewHGFilter.length) {
      setallNewHGroup(false);

    } else {
      const tempArray = displayNewHGFilter.map(hg => hg.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallNewHGroup(false);
          break;
        }
      }
      setallNewHGroup(true);
    }
    setNewHGroupSelectedIds(updatedValues);
  };

  const handleNewUFilterCheckboxChange = (value) => {
    const updatedValues = [...newUGroupSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayNewUGFilter.length) {
      setallNewUGroup(false);

    } else {
      const tempArray = displayNewUGFilter.map(ug => ug.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallNewUGroup(false);
          break;
        }
      }
      setallNewUGroup(true);
    }
    setNewUGroupSelectedIds(updatedValues);
  };

  function isArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Sort both arrays
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    // Compare each element
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;

  }

  const handleSubmit = async (event, filterKey, selectValue) => {
    event.preventDefault();
    let filterValue = [...selectValue];
    console.log("value of selected filters are ::::: " + JSON.stringify(selectValue));
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = JSON.parse(adminSession).siteid;
    if (filterKey == 4 && selectValue.length === filterHuntGList.length) {
      filterValue = [-1];

    } else if (filterKey == 6 && selectValue.length === filterUserGList.length) {
      filterValue = [-1];

    }
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: filterValue,
      filter_type: 1,
      filter_key: parseInt(filterKey),
      module_type: 4,
    }
    // if (loggedinUser.indexOf("@") !== -1) {
    //   update.agentid = loggedinUser;
    // }
    console.log("Modify group user filter value  :::: " + JSON.stringify(update));
    let saverep = await setGlobalLocationFilter(update);
    console.log(`reponse of Edit group user :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified group user data :::" + JSON.stringify(saverepeMsg)
    );
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      localStorage.setItem("s_message", saverepeMsg.message);
      // sessionStorage.removeItem('huntGroupFilter');
      // sessionStorage.removeItem('uGroupFilter');

      navigate("/userlanding", {
        state: { tab: "suser", tab2: "sgroups" },
      });
      window.location.reload();
    }
    else {
      localStorage.setItem("f_message", saverepeMsg.message);
    }
  }

  function handleSearch(e, flag) {
    const value = e.target.value;
    if (flag === 1) {
      setsearchHGValue(value);
      setdisplayHGFilter(customSearch(filterHuntGList, value, ['entity_name']));
    } else if (flag === 2) {
      setsearchUGValue(value);
      setdisplayUGFilter(customSearch(filterUserGList, value, ['entity_name']));
    } else if (flag === 3) {
      setsearchNewHGValue(value);
      setdisplayNewHGFilter(customSearch(filterHuntGList, value, ['entity_name']));
    } else {
      setsearchNewUGValue(value);
      setdisplayNewUGFilter(customSearch(filterUserGList, value, ['entity_name']));
    }
  }

  function setDefaultValue(e) {
    e.preventDefault();
    if (hgSelected) {
      setNewHGroupSelectedIds([]);
    }
    if (ugSelected) {
      setNewUGroupSelectedIds([]);
    }

  }

  const handleDeleteHuntFilters = (value) => {
    removeThisFilter(4);
  }
  const handleDeleteUserFilters = (value) => {
    removeThisFilter(6);
  }

  const removeallfilters = (value) => {
    removeThisFilter(-1);

  }
  function handleAllHGroups(e) {
    // e.preventDefault();
    setallHGroup(e.target.checked);
    if (e.target.checked) {
      const hgids = displayHGFilter.map(hg => hg.entity_id);
      setHGSelectedIds(hgids);
    } else {
      setHGSelectedIds([]);
    }

  }
  function handleAllUGroups(e) {
    // e.preventDefault();
    setallUGroup(e.target.checked);
    if (e.target.checked) {
      const ugids = displayUGFilter.map(ug => ug.entity_id);
      setUGSelectedIds(ugids);
    } else {
      setUGSelectedIds([]);
    }

  }
  function handleNewAllHGroups(e) {
    // e.preventDefault();
    setallNewHGroup(e.target.checked);
    if (e.target.checked) {
      const hg = displayNewHGFilter.map(hg => hg.entity_id);
      setNewHGroupSelectedIds(hg);
    } else {
      setNewHGroupSelectedIds([]);
    }

  }
  function handleNewAllUGroups(e) {
    // e.preventDefault();
    setallNewUGroup(e.target.checked);
    if (e.target.checked) {
      const ug = displayNewUGFilter.map(ug => ug.entity_id);
      setNewUGroupSelectedIds(ug);
    } else {
      setNewUGroupSelectedIds([]);
    }

  }

  async function removeThisFilter(filterKey) {
    const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    setIsloading(true);
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: [-1],
      filter_type: 1,
      filter_key: filterKey ? parseInt(filterKey) : -1,
      module_type: 4,
    }

    console.log("Modify User filter value  :::: " + JSON.stringify(update));
    let deleteFilter = await setGlobalLocationFilter(update);
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    let deleteMsg = await deleteFilter.json();
    console.log("Response... ");
    console.log(deleteMsg);
    if (deleteMsg.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      navigate("/userlanding", {
        state: { tab: "suser", tab2: "sgroups" },
      });
      window.location.reload();
    } else {
      localStorage.setItem("s_message", deleteMsg.message);
      // sessionStorage.removeItem("huntGroupFilter");
      // sessionStorage.removeItem("uGroupFilter");
      navigate("/userlanding", {
        state: { tab: "suser", tab2: "sgroups" },
      });
      window.location.reload();
    }
  }

 
  const handleManualSearch = (searchValue) => {
    setsearchValue(searchValue);
    const filteredUsers = customSearch(proccessdRows, searchValue, UIConstant.USER_GROUPS);

    setFilteredRows(filteredUsers);
};


  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <div className="position-absolute left__341px d-flex align-items-center">
        <div className="d-flex">
          <div className="ms-5 popconfirmFilter">
            {hgSelected && (
              <>
                <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                  <MDBChip  className="m-0" onClick={(e) => e.preventDefault()}>
                    <div className="filterElliipse">
                      {hgSelected}
                    </div>
                     <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => {e.stopPropagation(); handleDeleteHuntFilters() }} />
                  </MDBChip>
                </>}>
                  <MDBPopconfirmMessage>
                    <div className="fw-500">
                      Hunt Groups
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="w-100">
                        <MDBInput autoFocus placeholder="search" value={searchHGValue} onChange={(e) => handleSearch(e, 1)} />
                      </div>
                    </div>
                    <div className="filter-border"></div>
                    <div className="ps-2 pb-2 filtersScroll">
                      {displayHGFilter && displayHGFilter.map((group) => (
                        <div className="" key={group.entity_id}>
                          <MDBCheckbox name='flexCheck' value={group.entity_id} id={group.entity_id} label={group.entity_name} checked={hgSelectedIds.includes(group.entity_id)}
                            onChange={() => handleHGCheckboxChange(group.entity_id)}
                          />
                        </div>
                      ))}

                    </div>
                    <div className="filter-border"></div>
                    <div className="mt-3">
                      <MDBCheckbox checked={allHGroup} onChange={(e) => handleAllHGroups(e)} label='Select All' />
                    </div>
                    <div className="d-flex float-end">
                      {(hgSelectedIds.length > 0 && !isArraysEqual(hgSelectedIds, existHGSelectIds)) && (
                        <>
                          <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(1)}>Cancel</MDBBtn>
                          <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                            handleSubmit(e, 4, hgSelectedIds);
                          }}> Apply</MDBBtn>
                        </>
                      )}
                    </div>
                  </MDBPopconfirmMessage>
                </MDBPopconfirm>
              </>
            )}
          </div>
          <div className="mx-3 popconfirmFilter">
            {ugSelected && (<>
              <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                <MDBChip  className="m-0" onClick={(e) => e.preventDefault()}>
                  <div className="filterElliipse">
                    {ugSelected}
                  </div>
                   <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => {e.stopPropagation(); handleDeleteUserFilters() }} />
                </MDBChip>
              </>}>
                <MDBPopconfirmMessage>
                  <div className="fw-500">
                    User Groups
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="w-100">
                      <MDBInput autoFocus placeholder="search" value={searchUGValue} onChange={(e) => handleSearch(e, 2)} />
                    </div>
                  </div>
                  <div className="filter-border"></div>
                  <div className="mt-3">
                    <MDBCheckbox checked={allUGroup} onChange={(e) => handleAllUGroups(e)} label='Select All' />
                  </div>
                  <div className="ps-2 pb-2">
                    <div>
                      {displayUGFilter && displayUGFilter.map((group) => (
                        <div className="" key={group.entity_id}>
                          <MDBCheckbox name='flexCheck2' value={group.entity_id} id={group.entity_id} label={group.entity_name} checked={ugSelectedIds.includes(group.entity_id)}
                            onChange={() => handleUGCheckboxChange(group.entity_id)} />
                        </div>
                      ))}

                    </div>
                    <div className="filter-border"></div>
                    <div className="d-flex float-end mt-3">
                      {(ugSelectedIds.length > 0 && !isArraysEqual(ugSelectedIds, existUGSelectIds)) && (
                        <>
                          <MDBBtn size="sm" onClick={(e) => {
                            handleSubmit(e, 6, ugSelectedIds);
                          }}> Apply</MDBBtn>
                          <MDBBtn size="sm" color="secondary" className="ms-2" onClick={(e) => cancelfilterChanges(2)}>Cancel</MDBBtn>
                        </>
                      )}
                    </div>
                  </div>
                </MDBPopconfirmMessage>
              </MDBPopconfirm>
            </>
            )}


          </div>
        </div>
        {!(hgSelected && ugSelected) && (
          <div className="">
            <MDBPopconfirm placement='bottom-start' onClick={(e) => setDefaultValue(e)} btnChildren={(<>
              <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}
            </>)}>
              <MDBPopconfirmMessage className="p-2">
                <div>
                  <p className='mb-3 fw-600 filterhead'>
                    {showHuntGroup || showACQQueue || userGroups ? (showHuntGroup ? "Hunt Groups" : showACQQueue ? "ACQ Queue" : "User Groups") : "Filter by"}
                  </p>
                  {!showHuntGroup && !showACQQueue && !userGroups && (
                    <>
                      <div className={"d-flex flex-column " + (hgSelected !== "" ? "cursor-disabled" : "")}>
                        <div className={"cursor-pointer " + (hgSelected !== "" ? "Filter_disabled" : "")} onClick={toggleHuntGroup}>
                          Hunt Group
                        </div>
                      </div>
                      {/* Commenting the ACD Queue filter in groups section under users tab */}
                      {/* <div className="d-flex flex-column mt-2 cursor-disabled">
                        <div className="cursor-pointer mt-2 Filter_disabled" onClick={toggleACQQueue}>
                          ACQ Queue
                        </div>
                      </div> */}
                      <div className={"d-flex flex-column mt-2 " + (ugSelected !== "" ? "cursor-disabled" : "")}>
                        <div className={"cursor-pointer mt-2 " + (ugSelected !== "" ? "Filter_disabled" : "")} onClick={toggleUserGroup}>
                          User Groups
                        </div>
                      </div>
                    </>
                  )}

                  {showHuntGroup && (
                    <div className="">
                      <div className="d-flex align-items-center">
                        <div className="w-100">
                          <MDBInput autoFocus size="sm" placeholder="search" value={searchNewHGValue} onChange={(e) => handleSearch(e, 3)} />
                        </div>
                      </div>
                      <div className="filter-border py-2"></div>
                      <div className="mt-3">
                        <MDBCheckbox checked={allNewHGroup} onChange={(e) => handleNewAllHGroups(e)} label='Select All' />
                      </div>
                      <div className="filtersScroll">
                        {displayNewHGFilter && displayNewHGFilter.map((group) => (
                          <MDBCheckbox name='flexCheck' value={group.entity_id} id={group.entity_id} label={group.entity_name} checked={newHGroupSelectedIds.includes(group.entity_id)}
                            onChange={() => handleNewHFilterCheckboxChange(group.entity_id)} />
                        ))}
                      </div>
                    </div>
                  )}

                  {userGroups && (
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="w-100">
                          <MDBInput autoFocus size="sm" placeholder="search" value={searchNewUGValue} onChange={(e) => handleSearch(e, 4)} />
                        </div>
                      </div>
                      <div className="filter-border py-2"></div>
                      <div className="mt-3">
                        <MDBCheckbox checked={allNewUGroup} onChange={(e) => handleNewAllUGroups(e)} label='Select All' />
                      </div>
                      <div className="filtersScroll">
                        {displayNewUGFilter && displayNewUGFilter.map((group) => (
                          <div className="" key={group.entity_id}>
                            <MDBCheckbox name='flexCheck2' value={group.entity_id} id={group.entity_id} label={group.entity_name} checked={newUGroupSelectedIds.includes(group.entity_id)}
                              onChange={() => handleNewUFilterCheckboxChange(group.entity_id)} />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* {showACQQueue && (
                  <div>
                    <div className="">
                      <MDBCheckbox name='flexCheck2' value='' id='flexCheckDefault1' label='Super Admin' />
                    </div>
                    <div className="mt-2">
                      <MDBCheckbox name='flexCheck2' value='' id='flexCheckChecked2' label='Admin' />
                    </div>
                    <div className="mt-2">
                      <MDBCheckbox name='flexCheck2' value='' id='flexCheckChecked3' label='Supervisor' />
                    </div>
                    <div className="mt-2">
                      <MDBCheckbox name='flexCheck2' value='' id='flexCheckChecked4' label='User' />
                    </div>
                  </div>
                )} */}

                  {(showHuntGroup || showACQQueue || userGroups) && (
                    <MDBModalFooter className="d-flex align-items-center justify-content-between mt-3">
                      <MDBBtn size='sm' outline color='secondary' onClick={toggleBackClick} className="mx-0">
                        Back
                      </MDBBtn>
                      <div className="me-0">
                        {((showHuntGroup && newHGroupSelectedIds.length !== 0 && newHGroupSelectedIds.length !== filterHuntGList.length) ||
                          (userGroups && newUGroupSelectedIds.length !== 0 && newUGroupSelectedIds.length !== filterUserGList.length)) && (
                            <>
                              <MDBBtn size='sm' color='secondary' className="me-2" onClick={(e) => {
                                if (showHuntGroup) {
                                  cancelfilterChanges(3);
                                } else {
                                  cancelfilterChanges(4);
                                }
                              }}>
                                Cancel
                              </MDBBtn>
                            </>
                          )}

                        {(showHuntGroup && newHGroupSelectedIds.length !== 0 && newHGroupSelectedIds.length !== filterHuntGList.length) ? (
                          <MDBBtn size='sm' onClick={(e) => handleSubmit(e, 4, newHGroupSelectedIds)}>Apply</MDBBtn>
                        ) : (userGroups && newUGroupSelectedIds.length !== 0 && newUGroupSelectedIds.length !== filterUserGList.length) && (
                          <MDBBtn size='sm' onClick={(e) => handleSubmit(e, 6, newUGroupSelectedIds)}>Apply</MDBBtn>
                        )}
                      </div>

                      {/* <div className="me-0">
                        {((showHuntGroup && newHGroupSelectedIds.length !== 0 && newHGroupSelectedIds.length !== filterHuntGList.length) || (userGroups && newUGroupSelectedIds.length !== 0 && newUGroupSelectedIds.length !== filterUserGList.length)) && ()
                          <>
                          <MDBBtn size='sm' color='secondary' className="me-2" onClick={(e) => {
                            if (showHuntGroup) {
                              cancelfilterChanges(3)
                            } else {
                              cancelfilterChanges(4);
                            }
                          }}>
                            cancel
                          </MDBBtn>
                        </>
                  )}
                      {
                        (showHuntGroup && newHGroupSelectedIds.length !== 0 && newHGroupSelectedIds.length !== filterHuntGList.length) ? (
                          <MDBBtn size='sm' onClick={(e) => handleSubmit(e, 4, newHGroupSelectedIds)}>Apply</MDBBtn>
                        ) : (userGroups && newUGroupSelectedIds.length !== 0 && newUGroupSelectedIds.length !== filterUserGList.length) && (
                          <MDBBtn size='sm' onClick={(e) => handleSubmit(e, 6, newUGroupSelectedIds)}>Apply</MDBBtn>
                        )
                      }
                    </div> */}
                    </MDBModalFooter>
                  )}
                </div>
              </MDBPopconfirmMessage>
            </MDBPopconfirm>

          </div>
        )}
        {(hgSelected || ugSelected) && (
          <MDBBtn className="ms-2" onClick={removeallfilters}>Clear</MDBBtn>
        )}
      </div >
      <div className=" actionbar button_aligniment">
        <div className="float-end">
          <CommonMoreOptions
            DropDownitem={DropDownitem}
            disableMulti={disableMulti}
            agentList={groupList}
            userAllgroups={true}
            moduleType={4}
            moduleid="common-more-options-portal-Allgroups"
            showWarning={true}
            onImpExpRedirect={() => setShowImpExpRedirect(true)}
            onImpExpWarning={(msg) => { setWarningMessage(msg); warningToggle(); }}
          />
        </div>
      </div>
      <div className="w-100 usersDataTable mt-3">
        <div className="actionbar"></div>
        <div className='mb-2 mt-3 position-relative w-auto'>
        <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
      </div>
        <MDBDatatable
          key={searchValue}
          className="usersDataTable datatableSelect actioncolumn"
          onRowClick={(event, rowData) => {
            showThisInf(event);
          }}
          fixedHeader
          entries={50}
          maxHeight="63vh"
          sortField="Name"
          sortOrder="asc"
          searchInputProps={[]}
          data={{
            ...basicData,
            rows: filteredRows, // Use filtered rows here
          }}
          responsive
          hover
        />
      </div>
      <div id="common-more-options-portal-Allgroups"></div>
      {showWarning && (
        <ImportProgressWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          onOk={warningToggle}
          message={warningMessage}
        />
      )}
      {showImpExpRedirect && (
        <ImpExpRedirectPopup
          onProceed={() => {
            setShowImpExpRedirect(false);
            setfirstRequest(true);
            importuserToggle();
          }}
          onCancel={() => setShowImpExpRedirect(false)}
        />
      )}
      <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
        <MDBModalDialog size="fullscreen">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Import User Template</MDBModalTitle>
              {/* <MDBBtn className='btn-close' color='none' onClick={importuserToggle}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody className="pb-0">
              <ImportUser
                onClose={importuserToggle}
                setIsloading={setisLoading}
                onShow={setimportUser}
                show={importUser}
                firstRequest={firstRequest}
                setfirstRequest={setfirstRequest}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      {
        deleteFilter && (
          <PopupLoaderNew
            title={"Delete User"}
            content={<DeleteGroupsFilter
              filterKey={filterKey}
              groupInfo={props?.groupInfo ?? null}
              locUser={props?.locUsers ?? null}
              onClose={deleteFilterToggle}
              ref={deleteLocRef}
              setIsloading={setisLoading}
            />}
            onShow={setdeleteFilter}
            onClose={deleteFilterToggle}
            onSave={handleClick}
            isloading={isLoading}
            flag={4}
          />
        )
      }
    </>
  );
}
